import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';
import type { ComponentStyleConfig } from '@chakra-ui/theme';

const AccordionTimeline: ComponentStyleConfig = {
  parts: [
    'Accordion',
    'AccordionItem',
    'AccordionButton',
    'Box',
    'Icon',
    'TitleIcon',
    'AccordionPanel',
    'SubTitle',
  ],
  baseStyle: (props: StyleFunctionProps) => ({
    Accordion: {
      border: '1px',
      borderColor: mode('gray.200', 'gray.700')(props),
      bg: mode('white', 'gray.800')(props),
      borderRadius: 'md',
      borderTop: '0px',
    },
    AccordionItem: {
      border: 'unset',
      borderBottom: '1',
      borderBottomColor: mode('gray.100', 'gray.700')(props),
    },
    AccordionButton: {
      _focus: { boxShadow: 'unset' },
      p: '12px 24px',
      position: 'relative',
    },
    Box: {
      h: 5,
      w: 5,
      position: 'absolute',
      left: '-10px',
      display: 'flex',
      background: mode('white', 'gray.800')(props),
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      border: '1px',
    },
    Icon: {
      fontSize: 'xs',
    },
    TitleIcon: {
      color: mode('white', 'gray.800')(props),
      p: 1,
      borderRadius: '20%',
      h: 6,
      w: 6,
      mr: 4,
    },
    AccordionPanel: {
      pb: 4,
      pt: 2,
    },
    SubTitle: {
      color: mode('white', 'gray.800')(props),
      borderRadius: '5px',
      pl: 2,
      pr: 2,
      position: 'absolute',
      right: '10px',
      display: 'flex',
    },
  }),
};

export default AccordionTimeline;
